import { defaultClassNames } from "./classNames.default";
export const aanzetCustomClassNames = {
    ...defaultClassNames,
    caroussel: {
        clickableSecondary: 'white'
    },
    media: {
        block: "container--mg align--center",
        inner: "",
        visual: "container--s align--center"
    }
};
